import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'

import githubLogo from '../images/github.svg'
import twitterLogo from '../images/twitter.svg'

const Sidebar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  text-align: center;
  background-color: ${props => props.color};
`

const Lettering = styled.div`
  border-bottom: solid 0.02em;
  margin-bottom: 0.5em;
`

const Letter = styled.div`
  display: inline;
  color: #dddddd;
`

const NavLink = styled(Link)`
  color: #dddddd;
  display: block;
`

const SocialMediaLogo = styled.img`
  height: 0.7em;
  margin: 0.7em;
`

const Header = ({ className, lettering, color }) => (
  <Sidebar className={className} color={color}>
    <nav>
      <NavLink to="/" >
        <Lettering>
          {Array.from(lettering.toUpperCase()).map((char, index) => (
            <Letter key={index}>{char}</Letter>
          ))
          }
        </Lettering>
      </NavLink>
      <NavLink to="/blog">Blog</NavLink>
      <NavLink to="/stuff">Stuff</NavLink>
      <NavLink to="/about">About me</NavLink>
    </nav>

    <div>
      <a href="https://github.com/birkenstab" title="Github profile">
        <SocialMediaLogo src={githubLogo} alt="Github Logo" />
      </a>
      <a href="https://twitter.com/birkenstab" title="Twitter profile">
        <SocialMediaLogo src={twitterLogo} alt="Twitter Logo" />
      </a>
    </div>
  </Sidebar>
)

Header.propTypes = {
  lettering: PropTypes.string,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js